export const getLabel = (data) => (typeof data === 'string' ? data : data['label']);
const escapeRegExp = (str) => {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& signifie la chaîne correspondante entière
};
export const defaultMatching = (data, value) => {
    const escapedValue = escapeRegExp(value);
    const regex = new RegExp(`^${escapedValue}`, 'i');
    return data.filter((item) => regex.test(typeof item === 'string' ? item : item['label']));
};
//# sourceMappingURL=Autocomplete.helpers.js.map